import React, { createContext, useContext, useState } from "react";
import { IAgentBlueprint } from "../types/base";
import { Menu } from "../types/menu";
import { ISpotOnMenu, IToastConfig } from "@/types/pos";

interface AgentEditorContextType {
  localAgentBlueprint: IAgentBlueprint | null;
  setLocalAgentBlueprint: (agent: IAgentBlueprint | null) => void;
  menuData: Menu | null;
  setMenuData: (data: Menu | null) => void;
  spotOnMenus: ISpotOnMenu[] | null;
  setSpotOnMenus: (menus: ISpotOnMenu[] | null) => void;
  isSpotOnMenusLoading: boolean;
  setIsSpotOnMenusLoading: (isLoading: boolean) => void;
  toastConfig: IToastConfig | null;
  setToastConfig: (config: IToastConfig | null) => void;
  isToastConfigLoading: boolean;
  setIsToastConfigLoading: (isLoading: boolean) => void;
}

const AgentEditorContext = createContext<AgentEditorContextType | undefined>(
  undefined,
);

export function AgentEditorProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [localAgentBlueprint, setLocalAgentBlueprint] =
    useState<IAgentBlueprint | null>(null);

  const [menuData, setMenuData] = useState<Menu | null>(null);
  const [spotOnMenus, setSpotOnMenus] = useState<ISpotOnMenu[] | null>(null);
  const [isSpotOnMenusLoading, setIsSpotOnMenusLoading] = useState(false);
  const [toastConfig, setToastConfig] = useState<IToastConfig | null>(null);
  const [isToastConfigLoading, setIsToastConfigLoading] = useState(false);

  const contextValue: AgentEditorContextType = {
    localAgentBlueprint,
    setLocalAgentBlueprint,
    menuData,
    setMenuData,
    spotOnMenus,
    setSpotOnMenus,
    isSpotOnMenusLoading,
    setIsSpotOnMenusLoading,
    toastConfig,
    setToastConfig,
    isToastConfigLoading,
    setIsToastConfigLoading,
  };

  return (
    <AgentEditorContext.Provider value={contextValue}>
      {children}
    </AgentEditorContext.Provider>
  );
}

export const useAgentEditor = () => {
  const context = useContext(AgentEditorContext);
  if (context === undefined) {
    throw new Error(
      "useAgentEditor must be used within an AgentEditorProvider",
    );
  }
  return context;
};
